<div id="error-browser" fxLayout="column">
  <div
    id="error-browser-form-wrapper"
    fxLayout="column"
    fxLayoutAlign="center center">
    <div
      id="error-browser-form"
      [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div class="logo">
        <img src="assets/images/logos/logo.svg" alt="Logo ICT VS" />
      </div>
      <div class="title">{{ 'ERROR.BROWSER.TITLE' | translate }}</div>
      <div class="subtitle">
        {{ 'ERROR.BROWSER.SUBTITLE' | translate }} <br />
        {{ 'ERROR.BROWSER.UPDATE' | translate }}
      </div>
    </div>
  </div>
</div>
